/*
 * Action Types
 */
export enum CompanyReportTypes {
  LIST_COMPANY_REPORT_REQUEST = '@companyReport/LIST_COMPANY_REPORT_REQUEST',
  LIST_COMPANY_REPORT_SUCCESS = '@companyReport/LIST_COMPANY_REPORT_SUCCESS',
  LIST_COMPANY_REPORT_FAILURE = '@companyReport/LIST_COMPANY_REPORT_FAILURE',
}

export enum ImportationsReportTypes {
  IMPORTATIONS_REPORT_REQUEST = '@companyReport/IMPORTATIONS_REPORT_REQUEST',
  IMPORTATIONS_REPORT_SUCCESS = '@companyReport/IMPORTATIONS_REPORT_SUCCESS',
  IMPORTATIONS_REPORT_FAILURE = '@companyReport/IMPORTATIONS_REPORT_FAILURE',
}
/*
 * Data types
 */
export interface CompanyReportInterface {
  name: string;
  transportOperatorId?: string;
  months: {
    '1': string;
    '2': string;
    '3': string;
    '4': string;
    '5': string;
    '6': string;
    '7': string;
    '8': string;
    '9': string;
    '10': string;
    '11': string;
    '12': string;
  };
}
export interface ImportationsReportInterface {
  fileName: string;
  fileUrl: string;
  createdAt: string;
  company: string;
  value: number;
  nsu: number;
  transportOperatorId?: string;
}

/*
 * State type
 */
export interface CompanyReportState {
  readonly companyReportList: CompanyReportInterface[];
  readonly importationsReport: ImportationsReportInterface[];
  readonly totalCount: number;
  readonly loading: boolean;
  readonly error: boolean;
}
